"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GameDeck = _interopRequireDefault(require("./GameDeck"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Banker = /*#__PURE__*/function () {
  function Banker(_ref) {
    var store = _ref.store;

    _classCallCheck(this, Banker);

    _defineProperty(this, "store", null);

    _defineProperty(this, "attacker", null);

    _defineProperty(this, "deck", null);

    _defineProperty(this, "openedCards", []);

    _defineProperty(this, "discardPile", []);

    this.store = store;
    this.deck = new _GameDeck["default"]();
  }

  _createClass(Banker, [{
    key: "swapAttacker",
    value: function swapAttacker() {
      var nextIndex = this.attacker.index + 1;

      if (nextIndex >= this.store.gamblers.length) {
        nextIndex = 0;
      }

      this.setAttacker(this.store.gamblers[nextIndex]);
    }
  }, {
    key: "setAttacker",
    value: function setAttacker(gambler) {
      if (this.attacker) {
        this.attacker.attacker = false;
      }

      gambler.attacker = true;
      this.attacker = gambler;
    }
  }, {
    key: "isAttackerRobot",
    get: function get() {
      return this.attacker.isRobot;
    }
  }, {
    key: "isGameFinished",
    get: function get() {
      return this.deck.isEmpty;
    }
  }]);

  return Banker;
}();

exports["default"] = Banker;